export enum Environments {
  DEV = 'development',
  TEST = 'test',
  PROD = 'production',
  PREPROD = 'preprod',
  STAGING = 'staging',
}

export type Environment = 'development' | 'test' | 'production' | 'preprod' | 'staging';

const getEnv = (): Environment => {
  const envValue = (process.env.NODE_ENV || 'development') as Environment;
  return envValue;
};

export const isDev = () => 'development' === getEnv();
export const isTest = () => 'test' === getEnv();
export const isProd = () => 'production' === getEnv();
export const isPreProd = () => 'preprod' === getEnv();
export const isStaging = () => 'staging' === getEnv();

export default getEnv;
